var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// src/schema/componentManifestSchema.json
var componentManifestSchema_default = {
  $schema: "https://json-schema.org/draft/2019-09/schema",
  title: "Wix component manifest schema",
  type: "object",
  properties: {
    referredType: {
      description: "Reference to manifest to inherit from by URL or by comp type",
      $ref: "#/$defs/referredType"
    },
    selector: {
      description: "String describing how the user want us to select the component from the DOM",
      $ref: "#/$defs/selector"
    },
    displayName: {
      description: "The name of the component/widget",
      type: "string"
    },
    compType: {
      description: "String describing the current editor elements registry keys - to be deleted with final implementation",
      $ref: "#/$defs/compType"
    },
    definitions: {
      description: "Definitions of rules, properties and behaviors that are needed for the component/widget",
      type: "object",
      properties: {
        editingBehaviors: {
          description: "The editing behaviors ( relevant only for editor ) of the component/widget, it can be a single editing behaviors object or an array of refs and editingBehaviors",
          $ref: "#/$defs/editingBehaviors"
        },
        style: {
          description: "The styles properties of the component/widget, it can be a single style object or an array of refs and style",
          $ref: "#/$defs/style"
        }
      },
      additionalProperties: false
    },
    elements: {
      description: "The children of the container component/widget, representing the structure of the component/widget",
      type: "object",
      patternProperties: {
        "^[a-zA-Z0-9]+$": {
          $ref: "#"
        }
      }
    },
    presets: {
      description: "The design presets that are available for this component/widget",
      type: "object",
      patternProperties: {
        "^[a-zA-Z0-9]+$": {
          $ref: "#/$defs/preset"
        }
      }
    }
  },
  additionalProperties: false,
  $defs: {
    editingBehaviors: {
      type: "object",
      description: "The editing behaviors of the component/widget",
      properties: {
        selectable: {
          description: "Whether the component/widget is selectable in the editor by the user",
          type: "boolean"
        },
        removable: {
          description: "Whether the component/widget is removable in the editor by the user",
          type: "boolean"
        }
      },
      additionalProperties: false
    },
    style: {
      description: "The styles properties of the component/widget",
      type: "object",
      patternProperties: {
        "^[a-zA-Z0-9]+$": {
          type: "object",
          properties: {
            shapeOf: {
              description: "The type of the style",
              type: "string",
              enum: [
                "number",
                "length",
                "backgroundSize",
                "fontSize",
                "marginTop",
                "marginRight",
                "marginBottom",
                "marginLeft",
                "margin",
                "paddingTop",
                "paddingRight",
                "paddingBottom",
                "paddingLeft",
                "padding",
                "top",
                "right",
                "bottom",
                "left",
                "height",
                "width",
                "backgroundColor",
                "borderColor",
                "color",
                "borderWidth",
                "borderRadius",
                "font",
                "fontFamily",
                "boxShadow",
                "opacity",
                "alignSelf",
                "justifyContent"
              ]
            },
            editableStates: {
              description: "The states that the style can be edited in",
              type: "array",
              items: {
                type: "string"
              }
            }
          },
          additionalProperties: false
        }
      }
    },
    referredType: {
      description: "Reference to manifest to inherit from by URL or by comp type",
      type: "string"
    },
    selector: {
      description: "String describing how the user want us to select the component from the DOM",
      type: "string"
    },
    compType: {
      description: "String describing the current editor elements registry keys - to be deleted with final implementation",
      type: "string"
    },
    preset: {
      type: "object",
      properties: {
        displayName: { type: "string" },
        imgUrl: { type: "string" },
        cssUrl: { type: "string" }
      },
      required: ["displayName"],
      additionalProperties: false
    }
  }
};

export {
  __commonJS,
  __toESM,
  componentManifestSchema_default
};
//# sourceMappingURL=chunk-CBT2ZTXA.js.map
